import axios from "./ServicesConfig";

const orcamentoService = {
  async salvarOrcamento(data) {
    return await axios.post("/orcamentos", data);
  },
};
export default orcamentoService;
